import { render, staticRenderFns } from "./update-assessment-delivery-date.vue?vue&type=template&id=012db842&scoped=true"
import script from "./update-assessment-delivery-date.vue?vue&type=script&lang=js"
export * from "./update-assessment-delivery-date.vue?vue&type=script&lang=js"
import style0 from "./update-assessment-delivery-date.vue?vue&type=style&index=0&id=012db842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012db842",
  null
  
)

export default component.exports